import { render } from "./RichLink.vue?vue&type=template&id=e60ec234&scoped=true"
import script from "./RichLink.vue?vue&type=script&lang=js"
export * from "./RichLink.vue?vue&type=script&lang=js"

import "./RichLink.vue?vue&type=style&index=0&id=e60ec234&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60ec234"]])

export default __exports__